const pages = {
  index: '/pre-approval/create/:account',
  submissionsList: '/pre-approval/submissions/:account',
};

export default pages;
